export default __webpack_public_path__ + "static/media/canvas-dotted-18.16eb90e1.svg";